// extracted by mini-css-extract-plugin
export default {"toggle":"widgets-contacts-and-settings-fields-Address-AddressEditForm__toggle--vYfO2"};